import { useEffect, useRef } from 'react'

const EVENTOS = ['pointerdown', 'keydown', 'wheel', 'touchstart', 'scroll'] as const

export function useInatividadeKiosk(ativo: boolean, aoExpirar: () => void, ms: number): void {
  const aoExpirarRef = useRef(aoExpirar)

  useEffect(() => {
    aoExpirarRef.current = aoExpirar
  }, [aoExpirar])

  useEffect(() => {
    if (!ativo) return

    let timer: number | undefined
    const rearmar = (): void => {
      window.clearTimeout(timer)
      timer = window.setTimeout(() => aoExpirarRef.current(), ms)
    }

    rearmar()
    for (const ev of EVENTOS) window.addEventListener(ev, rearmar, { passive: true })

    return () => {
      window.clearTimeout(timer)
      for (const ev of EVENTOS) window.removeEventListener(ev, rearmar)
    }
  }, [ativo, ms])
}
